import { getApi, postApi } from "../../common/actions/net";

export const CUSTOMER_SUBSCRIPTIONS_LOADING = "SUBSCRIPTIONS_LOADING";
export const CUSTOMER_SUBSCRIPTIONS_LOADED = "SUBSCRIPTIONS_LOADED";
export const CUSTOMER_SUBSCRIPTIONS_FAILED = "SUBSCRIPTIONS_FAILED";

/**
 * Laddar ner kundens egna inställningar för notifikationer
 * @returns {func}
 */
export function getOwnCustomerSubscriptions() {
    return async (dispatch) => {
        dispatch({
            type: CUSTOMER_SUBSCRIPTIONS_LOADING
        });

        try {
            const {payload} = await dispatch(getApi("Customer/CustomerSubscriptionsQuery"));

            dispatch({
                type: CUSTOMER_SUBSCRIPTIONS_LOADED,
                subscriptions: payload
            });
        } catch(_) {
            dispatch({
                type: CUSTOMER_SUBSCRIPTIONS_FAILED
            });
        }
    };
}

export const CUSTOMER_SUBSCRIPTIONS_SAVING = "CUSTOMER_SUBSCRIPTIONS_SAVING";
export const CUSTOMER_SUBSCRIPTIONS_SAVED = "CUSTOMER_SUBSCRIPTIONS_SAVED";
export const CUSTOMER_SUBSCRIPTIONS_FAILED_SAVE = "CUSTOMER_SUBSCRIPTIONS_FAILED_SAVE";

/**
 * Sparar kundens egna inställningar för notifikationer.
 * @param {Object} customerSubscriptions 
 * @returns {func}
 */
export function saveCustomerSubscriptions(customerSubscriptions) {
    return async (dispatch) => {
        dispatch({
            type: CUSTOMER_SUBSCRIPTIONS_SAVING
        });

        try {
            const requestData = {
                mailAddressDeliveryNote: customerSubscriptions.mailAddressDeliveryNote,
                mailAddressInvoice: customerSubscriptions.mailAddressInvoice,
                mailAddressMonthReport: customerSubscriptions.mailAddressMonthReport,
                subscriptions: customerSubscriptions.subscriptions
            };
            await dispatch(postApi("Customer/CustomerSubscriptionsCommand", requestData));

            dispatch({
                type: CUSTOMER_SUBSCRIPTIONS_SAVED,
                customerSubscriptions: requestData
            });
        } catch(_) {
            dispatch({
                type: CUSTOMER_SUBSCRIPTIONS_FAILED_SAVE
            });
        }
    };
}